import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'trustedHtml',
})
export class TrustedHtmlPipe implements PipeTransform {
  private readonly dom_sanitizer = inject(DomSanitizer);

  transform(html: string | null | undefined): SafeHtml {
    if (!html) {
      return '';
    }

    return this.dom_sanitizer.bypassSecurityTrustHtml(html);
  }
}
